/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Blockstatusskipped2Inputs */

const zh_learn_blockstatusskipped2 = /** @type {(inputs: Learn_Blockstatusskipped2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已跳过`)
};

const en_learn_blockstatusskipped2 = /** @type {(inputs: Learn_Blockstatusskipped2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`skipped`)
};

const es_learn_blockstatusskipped2 = /** @type {(inputs: Learn_Blockstatusskipped2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`omitido`)
};

/**
* | output |
* | --- |
* | "skipped" |
*
* @param {Learn_Blockstatusskipped2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blockstatusskipped2 = /** @type {((inputs?: Learn_Blockstatusskipped2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blockstatusskipped2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blockstatusskipped2(inputs)
	if (locale === "en") return en_learn_blockstatusskipped2(inputs)
	return es_learn_blockstatusskipped2(inputs)
});
export { learn_blockstatusskipped2 as "learn_blockStatusSkipped" }